export const ROTA_FIDELIZE = "/admin/impulsione/fidelize";
export const ROTA_FIDELIZE_CASHBACK = "/admin/impulsione/fidelize/cashback";
export const ROTA_FIDELIZE_PONTUACAO = "/admin/impulsione/fidelize/pontuacao";
export const ROTA_FIDELIZE_CARTAO = "/admin/impulsione/fidelize/cartao-fidelidade";
export const ROTA_FIDELIZE_ROLETA = "/admin/impulsione/fidelize/roleta";
